import React, { Component, useState, Radio } from "react";

import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import moment from "moment";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import { ChangeDetectionStrategyType } from "ag-grid-react/lib/changeDetectionService";

import CustomLoadingOverlay from "./CustomLoadingOverlay";

const copyToClipBoard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};

class DeviceBooksParentTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: [],
            tableSearchKeyword: null,
            isGridReady: false,
            frameworkComponents: {
                customLoadingOverlay: CustomLoadingOverlay,
            },
            loadingOverlayComponent: "customLoadingOverlay",
            loadingOverlayComponentParams: { loadingMessage: "Loading..." },
        };
    }

    componentWillReceiveProps = (nextProps) => {
        if (this.state.isGridReady && nextProps.showLoading) {
            this.gridApi.showLoadingOverlay();
            return;
        }
        //if(nextProps.branches !== null && nextProps.devices !== null && this.props.devices !== nextProps.devices) {
        this.renderData(nextProps.devices);
        //}
    };

    renderData = (devices) => {
        var tableData = [];

        if (devices !== null && devices.length > 0) {
            if (this.state.tableSearchKeyword === null || !this.state.tableSearchKeyword) {
                devices.forEach((d) => tableData.push(d));
            } else {
                devices.forEach((d) => {
                    if (
                        d.did.indexOf(this.state.tableSearchKeyword) > -1 ||
                        d.userId.indexOf(this.state.tableSearchKeyword) > -1 ||
                        d.nurseryName.indexOf(this.state.tableSearchKeyword) > -1 ||
                        d.subscriberName.indexOf(this.state.tableSearchKeyword) > -1 ||
                        d.className.indexOf(this.state.tableSearchKeyword) > -1
                    ) {
                        tableData.push(d);
                    }
                });
            }
        }

        this.setState({ tableData: tableData }, () => {});
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.state.isGridReady = true;
        this.props.onGridReadyHandler();
    };

    onFirstDataRendered = (params) => {};

    onRowDataChanged = (params) => {
        this.setState({
            tableSummary: this.state.tableData.length.toLocaleString() + "/" + (this.props.devices ? this.props.devices.length : 0).toLocaleString(),
        });
        var allColumnIds = ["did", "userId", "nurseryName", "className", "childName", "birthDate", "childStatus", "childCreateDate", "store_id", "lastAccess"];
        params.columnApi.autoSizeColumns(allColumnIds, true);
    };
    onRowClicked = (params) => {
        if (params.api.getFocusedCell().column.getColId() === "disconnect") {
            if (window.confirm(`해당 디바이스의 연결을 해제하시겠습니까?`)) {
                axios({
                    method: "delete",
                    url: `/api/device/books/parent`,
                    data: {
                        did: params.data.did,
                    },
                })
                    .then((res) => {
                        const response = res.data;
                        if (response.code == 200) {
                            if (response.data.disconnected > 0) {
                                this.state.tableData.splice(params.rowIndex, 1);
                                this.setState({ tableData: this.state.tableData });
                                if (this.props.onDeviceDisconnectedHandler) {
                                    this.props.onDeviceDisconnectedHandler();
                                }
                            }
                            alert(response.msg);
                        } else {
                            alert(response.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        } else {
            this.props.onRowSelected(params.data.id);
        }
    };

    onSearchList = (e) => {
        var tableSearchKeyword = e.target.value;
        this.setState({ tableSearchKeyword: tableSearchKeyword });
    };

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.renderData(this.props.devices);
        }
    };

    onClickCopyAccount = (e, param) => {
        e.currentTarget.blur();
        if (param.value != null && param.value.length > 0) {
            var text = "";
            for (var i = 0; i < param.value.length; i++) {
                text += param.value[i] + "\r\n";
            }
            copyToClipBoard(text);
            this.props.toast("계정 목록을 클립보드에 복사하였습니다.", { type: this.props.toast.TYPE.INFO });
        }
    };

    onBtnExportDataAsCsv = () => {
        var fileName = "device_" + moment().format("YYYYMMDD") + ".csv";
        this.gridApi.exportDataAsCsv({ fileName: fileName });
    };

    listColumn = [
        {
            headerName: "DID",
            field: "did",
            sortable: true,
            minWidth: 170,
            pinned: "left",
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "계정",
            field: "userId",
            minWidth: 80,
            sortable: true,
            resizable: true,
            pinned: "left",
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "연결해제",
            field: "disconnect",
            maxWidth: 80,
            width: 80,
            pinned: "left",
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return `<button class='btn btn-danger' style='padding: 2px 6px'>해제</button>`;
            },
        },
        {
            headerName: "자녀",
            field: "childName",
            minWidth: 80,
            pinned: "left",
            sortable: true,
            resizable: true,
            cellClass: "text-center",
        },
        {
            headerName: "생일",
            field: "birthDate",
            minWidth: 80,
            cellClass: "text-center",
        },
        {
            headerName: "상태",
            field: "childStatus",
            minWidth: 80,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value == "present" ? "등록" : "대기";
            },
        },
        {
            headerName: "소속원",
            field: "nurseryName",
            minWidth: 100,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "클래스",
            field: "className",
            minWidth: 80,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "토모노트",
            field: "noteApproval",
            width: 80,
            sortable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value == "AP" ? `<span class="text-success">승인</span>` : param.value == "NA" ? `<span class="text-danger">해지</span>` : param.value;
            },
        },
        {
            headerName: "토모동화",
            field: "booksApproval",
            width: 80,
            sortable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                let approval = param.data.booksApproval;
                if (approval != "AP") {
                    approval = param.data.homebooksApproval == "AP" ? param.data.homebooksApproval : approval;
                }
                return approval == "AP" ? `<span class="text-success">승인</span>` : approval == "NA" ? `<span class="text-danger">해지</span>` : approval;
            },
        },
        {
            headerName: "등록일",
            field: "childCreateDate",
            minWidth: 80,
            sortable: true,
            resizable: true,
            cellClass: "text-center",
        },
        {
            headerName: "스토어",
            field: "storeId",
            maxWidth: 100,
            width: 80,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "최근접속일",
            field: "lastAccess",
            width: 170,
            sortable: true,
            resizable: true,
            cellClass: function (param) {
                return "text-center";
            },
            cellRenderer: (param) => {
                return param.value;
            },
        },
    ];

    render() {
        return (
            <div className="card border-top border-3 border-top-info">
                <div className="card-body" style={{}}>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-3 text-left table-total-summary">{this.state.tableSummary}</div>
                        <div className="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-9 mb-1">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-5 col-sm-5 col-5"></div>
                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                                    <Button className="btn btn-secondary" onClick={() => this.onBtnExportDataAsCsv()}>
                                        CSV로 저장
                                    </Button>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-md-5 col-sm-5 col-5">
                                    <input className="form-control" type="text" onChange={(e) => this.onSearchList(e)} onKeyPress={this.handleKeyPress} placeholder="DID/계정/이름/원/클래스 검색" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <AgGridReactEx
                                height={400}
                                columnDefs={this.listColumn}
                                defaultColDef={{ resizable: true }}
                                rowData={this.state.tableData}
                                enableCellTextSelection={true}
                                ensureDomOrder={true}
                                onGridReady={this.onGridReady}
                                onRowClicked={this.onRowClicked.bind(this)}
                                onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                onRowDataChanged={this.onRowDataChanged}
                                rowDataChangeDetectionStrategy={ChangeDetectionStrategyType.IdentityCheck}
                                enableCellChangeFlash={true}
                                frameworkComponents={this.state.frameworkComponents}
                                loadingOverlayComponent={this.state.loadingOverlayComponent}
                                loadingOverlayComponentParams={this.state.loadingOverlayComponentParams}
                                overlayNoRowsTemplate={`<span>기기 목록이 없습니다.</span>`}
                                suppressSizeColumnsToFit={true}
                            ></AgGridReactEx>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeviceBooksParentTable;
